import { render } from "./BatchBankAccountSelection.vue?vue&type=template&id=4623f6f0"
import script from "./BatchBankAccountSelection.vue?vue&type=script&lang=js"
export * from "./BatchBankAccountSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__